const constants = {
    formname: "contactUs",
    title: "מה תרצו לכתוב לנו?",
    getTitle: (isMaleGender) => `מה ${isMaleGender ? "תרצה" : "תרצי"} לכתוב לנו?`
}

export default constants